import React from 'react';

export const VideoOffIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_36394_36656)">
        <path
          d="M6.17035 5.81055L4.75342 7.45565L6.32082 9.11403C5.581 9.87025 5.11705 10.9316 5.11705 12.1124V20.1787C5.11705 22.4872 6.88508 24.3578 9.0669 24.3578H18.0951C18.86 24.3578 19.5747 24.119 20.1766 23.721L23.4243 27.1439L24.8412 25.4988L6.17035 5.81055ZM18.0951 21.9697H9.0669C8.12646 21.9697 7.37411 21.1605 7.37411 20.1787V12.1124C7.37411 11.595 7.58727 11.1306 7.92583 10.7989L18.4713 21.9167C18.3459 21.9432 18.2205 21.9697 18.0951 21.9697ZM27.4368 9.37937C26.6218 8.88849 25.6437 8.90176 24.8412 9.41917L21.9697 11.2633C21.5935 9.3661 20.0011 7.93327 18.0951 7.93327H9.91956L12.1892 10.3213H18.1076C19.0481 10.3213 19.8004 11.1306 19.8004 12.1124V18.3479L22.9227 21.6381L24.8412 22.8719C25.255 23.1372 25.7189 23.2699 26.1703 23.2699C26.5967 23.2699 27.0356 23.1505 27.4368 22.9117C28.2519 22.4208 28.7534 21.5319 28.7534 20.5369V11.7144C28.7534 10.7193 28.2644 9.83045 27.4368 9.33957V9.37937ZM26.4838 20.5634C26.4838 20.7227 26.3961 20.8155 26.3208 20.8553C26.2456 20.8951 26.1327 20.9349 26.0073 20.8553L23.1735 19.0245V13.2931L26.0073 11.4623C26.1327 11.3827 26.2581 11.4092 26.3208 11.4623C26.3961 11.5021 26.4838 11.595 26.4838 11.7542V20.5767V20.5634Z"
          fill="#D9ECFA"
        />
      </g>
      <defs>
        <clipPath id="clip0_36394_36656">
          <rect width="32" height="32" fill="white" transform="translate(0.753418 0.476562)" />
        </clipPath>
      </defs>
    </svg>
  );
};
